import { render, staticRenderFns } from "./Akt.vue?vue&type=template&id=a9b4104a&scoped=true"
import script from "./Akt.vue?vue&type=script&lang=ts"
export * from "./Akt.vue?vue&type=script&lang=ts"
import style0 from "./Akt.vue?vue&type=style&index=0&id=a9b4104a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b4104a",
  null
  
)

export default component.exports